module.exports = __webpack_public_path__ + "static/img/cybercrime.9989de4b.png";